export class MoleculePanelOverviewHeaderMultiDeleteRestorableWebhostingActionComponent {
    public templateUrl = require('./multi-delete-restorable-webhosting-action.html?external');
}
